<template>

  <div class="padded">

    <data-table
      table-ref="utiltable"

      :title="tableTitle"
      icon="fa fa-plug"

      :url="'/utility/site/' + rowData.id"

      :fields="fields"

      :hide-top="hideHeading"
      :show-title="showTitle"
      :show-search="showSearch"

      :add-action="canAccess('finance|admin') ? action : null"
      :add-props="canAccess('finance|admin') ? addPropsData : null"
      detail-component="utility-detail-row">
<!--
        <template slot="bills-slot" slot-scope="props">
          <utility-bill-action :site-data="props.rowData" />
        </template>
-->
    </data-table>

  </div>

</template>


<script>
import Vue from 'vue'

import {settings} from '@/components/Data'

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

import UtilityControls from '@/components/utility/UtilityControls'
import UtilityDetail from '@/components/utility/UtilityDetail'
import UtilityAction from '@/components/actions/UtilityBillAction'

Vue.component('utiity-controls', UtilityControls)
Vue.component('utility-detail-row', UtilityDetail)

export default {
  mixins: [DateMixins, NumberMixins],

  components: {
    UtilityAction
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },

    noAdd: {
      type: Boolean,
      default: false
    },

    title: {
      type: String,
      default: 'Utility Bills'
    },

    hideHeading: {
      type: Boolean,
      default: false
    },

    showTitle: {
      type: Boolean,
      default: true
    },

    showSearch: {
      type: Boolean,
      default: true
    },

    readOnly: {
      type: Boolean,
      default: false
    }

  },

  data () {
    return {
      action: UtilityAction,
      addPropsData: {
        siteData: this.rowData,
        editMode: false,
        readOnly: this.readOnly
      },

      label: this.getUtilLabel(this.rowData),
      localData: this.rowData,

      fields: [
        {
          name: '__sequence',
          title: '#'
//          sortField: 'id'
        },
        {
          name: 'date',
          title: 'Date',
//          sortField: 'date',
          callback: 'formatDate|D MMM YYYY'
        },
        {
          name: 'amount',
          title: settings.utilAmountLabel,
//          sortField: 'amount',
          callback: this.formatNumber,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down text-right'
        },
        {
          name: 'tax',
          title: settings.taxName,
          visible: this.showTax(),
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down text-right'
        },
/*        {
          name: 'untaxedCharges',
          title: 'Untaxed Amt',
//          sortField: 'untaxedCharges',
          callback: this.formatNumber,
          visible: this.showTax(),
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'penalty',
          title: 'Penalty',
          callback: this.formatNumber,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        }, */
        {
          name: 'total',
          title: 'Total',
          dataClass: 'text-right',
//          sortField: 'total',
          callback: this.formatNumber
        },
        {
          name: 'paid',
          title: 'Paid',
//          sortField: 'paid',
          callback: this.formatBoolean,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'paidDate',
          title: 'Paid Date',
//          sortField: 'paidDate',
          callback: 'formatDate|D MMM YYYY',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
/*        {
          name: '__slot:bills-slot',
          title: ''
        }, */
        {
          name: '__component:utiity-controls',
          title: ''
        }
      ]

    }
  },  // data

  computed: {
    tableTitle: function () {
      return this.title ? this.title : this.label + ' Bills'
    }
  }
}

</script>
